import apiClient from './apiClient';

const surveyService = {
  getStatus: async (studentId) => {
    const res = await apiClient.get(`/Surveys/status`, { params: { studentId } });
    return res.data;
  },
  submit: async ({ studentId, verbalRating, verbalReason, mathRating, mathReason }) => {
    const payload = {
      studentId,
      verbalRating,
      verbalReason: verbalRating >= 3 ? null : (verbalReason || '').trim(),
      mathRating,
      mathReason: mathRating >= 3 ? null : (mathReason || '').trim(),
    };
    const res = await apiClient.post(`/Surveys/submit`, payload);
    return res.data;
  },
  getMine: async (studentId) => {
    const res = await apiClient.get(`/Surveys/mine/${studentId}`);
    return res.data;
  }
};

export default surveyService;
